import * as yup from 'yup';

export const editProfileSchema = yup.object().shape({
  name: yup
    .string()
    .required('Name cannot be emplty!')
    .max(70, 'Name must not exceed 70 characters'),

  phoneNumber: yup
    .string()
    .required('Phone Number cannot be emplty!')
    .max(15, 'Phone Number must not exceed 15 characters')
    .matches(
      /^\+[1-9]{1}[0-9]{1,3}[0-9]{9,12}$/,
      'Phone number is not valid. It should be in the format: +[countryCode][Number]'
    ),
});

export const editProfileValidate = async (data) => {
  try {
    await editProfileSchema.validate(data, { abortEarly: false });
    return {}; // No errors
  } catch (err) {
    return err.inner.reduce((acc, error) => {
      acc[error.path] = error.message;
      return acc;
    }, {});
  }
};
